<template>
  <Card>
    <AjaxForm :route="'admin/RequestBrand/Edit/'+req._id" v-if="req">
      <div class="row">
        <div class="col-12 col-sm-12 col-md-4 mb-3">
          <label >شماره درخواست :</label>
          {{req.number}}
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-3">
          <label>درخواست دهنده :</label>
          {{req.user_id.title}} {{req.user_id.phone}}
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-3">
        <label>  تاریخ درخواست :</label>
          {{req.created}}
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-3">
          <label>عنوان : </label>
          {{req.title}}
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-3">
          <label>عنوان انگلیسی : </label>
          {{req.en_title}}
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-3">
          <label>کشور : </label>
          {{req.country_title}}
        </div>
        <div class="col-12 col-sm-12 col-md-3 mb-3">
          <label>صنف مرتبط :</label>
          {{req.guild_title}}
        </div>
        <div class="col-12 col-sm-12 col-md-12 mb-3">
          <label>توضیحات برند : </label>
          <div>
            {{req.description}}
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-12 mb-3">
          <label class="d-block">تصاویر بارگذاری شده : </label>
          <div class="pics-div">
            <a target="_blank" v-for="p in req.pic" :key="p" :href="prefix+p">
              <img alt="" :src="prefix+p"/>
            </a>
          </div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-3">
          <label>آخرین ویرایش کننده : </label>
          <div v-if="req.last_edit_user_id">
            <div>{{req.last_edit_user_id.fullname}}</div>
            <div>{{req.last_edit}}</div>
          </div>
          <div v-else>--</div>
        </div>
        <div class="col-12 col-sm-12 col-md-4 mb-3">
          <CustomInput input_style="twoLine"
                       type="select" name="status"
                       :select-options="statuses"
                       v-model="select_status"
                       reduce_select="value"
                       placeholder="وضعیت را انتخاب کنید"
                       select-label="title"
                       label="انتخاب وضعیت"></CustomInput>
        </div>
        <div class="col-12 col-sm-12 col-md-8 mb-3">
          <CustomInput input_style="twoLine" type="textarea" name="deny_reason" placeholder="دلیل رد کردن..."
          label="دلیل رد درخواست :"
                       v-model="req.deny_reason"
          ></CustomInput>
        </div>
      </div>
      <div class="row mt-3">
        <div class="col-10 col-md-5 mx-auto">
          <button class="btn btn-info btn-block btn-lg" type="submit">ثبت اطلاعات</button>
        </div>
      </div>
    </AjaxForm>
    <div v-if="error" class="alert-danger alert">{{error}}</div>
  </Card>
</template>

<script>
import Card from "@/components/forms/Card";
import {mapActions} from "vuex";
import {AppApi} from "@/api/AppApi";
import {date, findSelectItem} from "@/shared/helper";
import CustomInput from "@/components/CustomInput";
import AjaxForm from "@/components/forms/AjaxForm";
export default {
name: "RequestRegisterBrandEdit",
  components: {AjaxForm, CustomInput, Card},
  data()
  {
    return{
      req : null,
      error:null,
      id : this.$route.params.id,
      pic_prefix: process.env.VUE_APP_API_URL+process.env.VUE_APP_USER_STORAGE,
      statuses : [
        {title :'درانتظار بررسی',value : 'waiting'},
        {title :'تایید شده',value : 'confirmed'},
        {title :'رد شده',value : 'denied'},
      ],
      select_status : null,
      prefix:process.env.VUE_APP_API_URL+process.env.VUE_APP_USER_STORAGE,
    }
  },
  mounted()
  {
    this.setPageTitle('ویرایش درخواست ثبت برند');
    this.setShowHead(true);
    this.setPageLoading(false);
    this.initPage();
  },
  methods:{
    ...mapActions('app',{
      setPageTitle:'setPageTitle',
      setPageLoading:'setPageLoading',
      setShowHead : 'setShowHead'
    }),
    async initPage()
    {
      this.setPageLoading(true);
      this.error = null;
      this.req = null;
      this.id = this.$route.params.id;
      const result = await AppApi.getRequestRegisterBrand(this.id);
      if (result.ok)
      {
        this.req = result.req;
        this.req.created = date(this.req.createdAt,true);
        if (this.req.last_edit_date)
          this.req.last_edit = date(this.req.last_edit_date,true);
        const st = this.req.status;
        if (st === 'waiting')
          this.req.status_label = 'درانتظار بررسی';
        else if (st === 'confirmed')
          this.req.status_label = 'تایید شده';
        else if (st === 'denied')
          this.req.status_label = 'رد شده';
        if (this.req.logo_name)
        {
          this.req.logo_url = this.pic_prefix+this.req.logo_name;
        }
        if (this.req.registered_doc_pic_name)
        {
          this.req.registered_doc_pic_url = this.pic_prefix+this.req.registered_doc_pic_name;
        }
        this.select_status = findSelectItem(this.req.status,this.statuses,'value');
      }
      else
      {
        this.error = result.error;
      }

      this.setPageLoading(false);
    }
  }
}
</script>

<style scoped>
.pics-div
{
  display: flex;
  justify-content: flex-start;
  grid-column-gap: 10px;
}
.pics-div a
{
  flex: 0 0 100px;
  width: 100px;
  height: 100px;
  display: block;
  box-shadow: 0 0 5px 1px #0000004d;
}
.pics-div img
{
  width: 100%;
  height: 100%;
  object-fit: contain;
}
</style>